/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { A11y, Autoplay, EffectFade } from "swiper/modules";
import { Swiper as SwiperComponent, SwiperSlide } from "swiper/react";
import "./Slider.scss";

const Swiper = props => (
	<SwiperComponent modules={[A11y, Autoplay, EffectFade]} {...props}>
		{props.children}
	</SwiperComponent>
);

export { Swiper, SwiperSlide };
